
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.356 1.878c.254-.015.473.165.49.402l.576 8.603v.005c.016.289.223.452.463.452h5.307c.238 0 .443-.16.463-.457l.577-8.603c.016-.237.235-.417.489-.402.254.015.448.219.432.456l-.577 8.602c-.046.697-.602 1.264-1.384 1.264H2.885c-.775 0-1.344-.562-1.384-1.266l-.577-8.6c-.016-.237.177-.441.432-.456z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 2.346c0-.259.207-.47.462-.47h10.153c.255.001.462.211.462.47 0 .26-.207.47-.462.47H.462A.465.465 0 010 2.345z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.278.86a.287.287 0 00-.096.016.256.256 0 00-.081.047.214.214 0 00-.054.07.186.186 0 00-.02.081v1.077c0 .237-.225.43-.503.43s-.503-.193-.503-.43V1.076c0-.141.032-.281.095-.412.063-.13.156-.25.273-.35.117-.1.256-.179.41-.233C3.95.027 4.114 0 4.28 0h2.516c.166 0 .33.027.482.081.154.054.293.133.41.233.117.1.21.22.273.35.063.13.095.27.095.412v1.075c0 .237-.226.43-.504.43s-.503-.193-.503-.43V1.074A.186.186 0 007.03.992a.214.214 0 00-.054-.07.256.256 0 00-.082-.046A.287.287 0 006.8.86H4.278zM3.255 3.441c.278-.008.51.177.52.415l.253 6.022c.01.237-.208.436-.486.445-.278.008-.51-.177-.52-.415l-.253-6.022c-.01-.237.208-.436.486-.445zm4.567 0c.278.009.495.208.485.445l-.251 6.022c-.01.238-.244.423-.522.415-.278-.009-.495-.208-.485-.445l.252-6.022c.01-.238.243-.423.521-.415zm-2.284 0c.278 0 .504.193.504.43v6.022c0 .237-.226.43-.504.43s-.503-.193-.503-.43V3.87c0-.237.225-.43.503-.43z"}})])
          )
        }
      }
    